import { ILocation } from "../interfaces/common/location";

export const emptyLocation: ILocation = {
    id: "",
    url: "",
    place_id: "",
    directions: "",
    phone_number: '',
}